import { isValidLogin } from "react/utils/utils";

/* Model */
class DriverModel extends App.Models.BaseModel {
    modelUrl = 'Driver';
}

App.Models.Driver = DriverModel;

/* Collection */
class DriverCollection extends App.Collections.BaseCollection {
    url = 'Driver';
    model = App.Models.Driver;
}

App.Collections.Drivers = DriverCollection;

/* Router */
class DriverRouter extends App.Routers.BaseRouter {
    constructor() {
        const entityName = 'Driver';
        const model = App.Models.Driver;
        const collectionClass = App.Collections.Drivers;

        super(entityName, model, collectionClass);
    }

    beforeDestroy = (that, id) => {

        if (Monet.Session.User.id === id) {
            var monetMessage = new Monet.Form.Messages.AlertMessage();

            monetMessage.setMessage({
                errorMessages: [Monet.Form.Messages.mountErrorMessageObject("User.Delete.yourself")]
            });

            monetMessage.setScope("#form_Driver");
            monetMessage.triggerMessage();
            window.location = "#/" + this.entityName;

            return false;
        }
        return true;
    }

    beforeCreate = (model_to_create) => {
        model_to_create.modelUrl = 'Driver/Save';
    }

    getUnavailableDates = dateFields => {
        const invalidDates = [];

        for (const field in dateFields) {
            const fieldInstance = dateFields[field];

            const dateFieldUtils = Greenmile.Utils.DateFieldsFunctions;
            const fieldName = dateFieldUtils.getFutureDateFieldName(fieldInstance);

            fieldName && invalidDates.push(fieldName);
        }

        return invalidDates;
    }

    showFutureDatesError = fieldsNames => {
        const dateFieldUtils = Greenmile.Utils.DateFieldsFunctions;

        dateFieldUtils.showFutureDatesError({
            fieldsWithError: fieldsNames,
            scope: '#Driver #form_and_grid'
        });

        App.Forms.Driver.form.triggerLoadingBtns();
    }

    getDateFieldsAfterToday = () => {
        const {
            lastAlcoholTest,
            lastDrugsTest,
            lastPhysicalTest
        } = App.Forms.Driver.form.fields;

        const dateFieldsToVerify = {
            lastAlcoholTest,
            lastDrugsTest,
            lastPhysicalTest
        };

        const afterTodayDateFields = this.getUnavailableDates(dateFieldsToVerify);

        return afterTodayDateFields;
    }

    beforeSave = nextFunction => {
      const invalidDateFieldsNames = this.getDateFieldsAfterToday();

      if (invalidDateFieldsNames.length) {
        this.showFutureDatesError(invalidDateFieldsNames);

        return;
      }

      const driverForm = App.Forms.Driver.form;

      const confirmAction = () => {
        nextFunction();
      };

      const cancelAction = () => {
        driverForm.triggerLoadingBtns();
      };

      const props = {
        customConfirmButtonResource: 'emptyUserPasswordAlert.confirmButton',
        customCancelButtonResource: 'default.button.close'
      };

      const isCreateStage = driverForm.crudStage === 'new';

      if (isCreateStage) {
        const passwordValue = driverForm.fields?.password?.getValue() ?? "";

        if (!passwordValue) {
          new Greenmile.Components.AlertModal(
            'emptyUserPasswordAlert.description',
            'emptyUserPasswordAlert.title',
            confirmAction,
            cancelAction,
            props
          ).show();

          return;
        }
      }

      if(['edit', 'new'].includes(driverForm.crudStage)) {
        const loginField = driverForm.fields?.login;
        const loginValue = loginField?.getValue() ?? "";
        const loginElement = loginField?.rootEl;

        if (!isValidLogin(loginValue)) {

          const monetMessage = new Monet.Form.Messages.InlineMessage();
          const resourceMessage = Monet.I18n.getResourcesByKey("user.login.invalid");

          monetMessage.setScope(`#${this.entityName}`);
          monetMessage.setInfoType("error");
          monetMessage.setMessage(resourceMessage);
          monetMessage.triggerMessage();
          driverForm.triggerLoadingBtns();

          loginElement.classList.add('error');
          loginElement.classList.add('control-group');

          return;
        } else {
          loginElement.classList.remove('error');
          loginElement.classList.remove('control-group');
        }
      }

      nextFunction();
    }

    afterCreateForm = (entity, _, crudStage) => {
      if(['edit', 'new'].includes(crudStage)) {
        const loginFieldId = App.Forms[entity].form.fields.login.getId();
        const tooltipElement = document.createElement('span');
        tooltipElement.className = 'MonetUIHelpLink';
        tooltipElement.dataset.title = Monet.I18n.getResourcesByKey("user.login.invalid");
        const loginLabel = document.querySelector(`#${loginFieldId} label`);

        loginLabel.classList.add('withHelper');
        loginLabel.appendChild(tooltipElement);
      }
    }

    afterPopulateForm = () => {
      const driverForm = App.Forms.Driver.form;
      const isEditStage = driverForm.crudStage === 'edit';

      if (isEditStage) {
        driverForm.fields?.externalUser?.disable();
      }
    }
}

App.Routers.Driver = DriverRouter;
